<template>
	

	<div class="">
		<app-header/>
		
			<div class="content container">
				<h2 class="mb">API</h2>


				<div class="row">
					Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
					tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
					quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
					consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
					cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
					proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
				</div>
				
			</div>
			
		<app-footer/>

	</div>
</template>


<script>
import Vue from "vue";

import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";
import AppLoader from "@/components/AppLoader.vue";

export default Vue.extend({
  components: {
    AppHeader,
    AppFooter,
    AppLoader
  },
  data: function() {
    return {
      files: [],
      loading: true
    };
  },
  methods: {
    getFiles: function() {
      this.loading = true;
    }
  },

  mounted: function() {
    this.getFiles();
  }
});
</script>


<style lang="scss">
</style>
